import { generatePath } from 'react-router';

export const embeddedFormRoutes = {
  flowOnlyInauth: {
    path: '/efia/fl/:flowLabel',
    build({ flowLabel }: { flowLabel: string }) {
      return generatePath(this.path, { flowLabel });
    },
  },
  flowAndVariantInauth: {
    path: '/efia/fl/:flowLabel/v/:variant',
    build({ flowLabel, variant }: { flowLabel: string; variant: string }) {
      return generatePath(this.path, { flowLabel, variant });
    },
  },
  flowOnlyAuth: {
    path: '/efa/fl/:flowLabel',
    build({ flowLabel }: { flowLabel: string }) {
      return generatePath(this.path, { flowLabel });
    },
  },
  flowAndVariantAuth: {
    path: '/efa/fl/:flowLabel/v/:variant',
    build({ flowLabel, variant }: { flowLabel: string; variant: string }) {
      return generatePath(this.path, { flowLabel, variant });
    },
  },
  freddieRefillGlobal: '/efa/fl/freddie-refill-global',
} as const;
